import { controls,grouped } from "../controls";
const interest_rates = {
label: "Interest Rates",
pageLabel: "Interest Rates",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
...controls.magicDateLabel({ tab: "filter", label: "Trdate",target: "trdate"}),
...controls.magicDate({ tab: "filter", name: "trdate", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "From Amount"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "from_amount",maxlength:21}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "To Amount"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "to_amount",maxlength:21}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "From Months"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "from_months",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "To Months"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "to_months",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "From Days"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "from_days",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "To Days"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "to_days",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Int Rate"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "int_rate",maxlength:13}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Senior Rate"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "senior_rate",maxlength:13}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Staff Rate"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "staff_rate",maxlength:13}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Woman Rate"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "woman_rate",maxlength:13}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Society Rate"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "society_rate",maxlength:13}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Demography"}),
...controls.oc({ tab: "filter", c: "Demography", placeHolder: "Demography Code", name: "InterestRate-demography-demography_code",fastpath: "demographies"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "InterestRate-demography-demography_display"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Product",star:false}),
...controls.oc({ tab: "general", c: "Product", placeHolder: "Product Code", name: "product_code",fastpath: "products",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "product_display"}),
...controls.magicDateLabel({ tab: "general", label: "Trdate",target: "trdate",star:false}),
...controls.magicDate({ tab: "general", name: "trdate", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "From Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "from_amount",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "To Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "to_amount",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "From Months",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "from_months",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "To Months",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "to_months",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "From Days",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "from_days",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "To Days",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "to_days",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Int Rate"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "int_rate",maxlength:8}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Senior Rate"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "senior_rate",maxlength:8}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Staff Rate"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "staff_rate",maxlength:8}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Woman Rate"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "woman_rate",maxlength:8}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Society Rate"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "society_rate",maxlength:8}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Demography",star:false}),
...controls.oc({ tab: "general", c: "Demography", placeHolder: "Demography Code", name: "demography_code",fastpath: "demographies",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "demography_display"}),
]
,history:{
perPage: 10,
reportHeader: "Interest Rates",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Trdate",accessor: "trdate",type:'date'},
{Header: "From Amount",accessor: "from_amount",},
{Header: "To Amount",accessor: "to_amount",},
{Header: "From Months",accessor: "from_months",},
{Header: "To Months",accessor: "to_months",},
{Header: "From Days",accessor: "from_days",},
{Header: "To Days",accessor: "to_days",},
{Header: "Int Rate",accessor: "int_rate",},
{Header: "Senior Rate",accessor: "senior_rate",},
{Header: "Staff Rate",accessor: "staff_rate",},
{Header: "Woman Rate",accessor: "woman_rate",},
{Header: "Society Rate",accessor: "society_rate",},
{Header: "Demography",accessor: "InterestRate-demography-demography_display",},
]}};
export default interest_rates;